import {jsx as _jsx} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import { usePreloadedQuery} from 'react-relay'

import TeamInvitationDialog from './TeamInvitationDialog'
import TeamInvitationMeetingAbstract from './TeamInvitationMeetingAbstract'
import TeamInvitationWrapper from './TeamInvitationWrapper'





const query = graphql`
  query TeamInvitationQuery($token: ID!) {
    verifiedInvitation(token: $token) {
      ...TeamInvitationDialog_verifiedInvitation
      meetingType
    }
  }
`
function TeamInvitation(props) {
  const {queryRef} = props
  const data = usePreloadedQuery(query, queryRef)

  const {verifiedInvitation} = data
  const {meetingType} = verifiedInvitation
  const Wrapper = meetingType ? TeamInvitationMeetingAbstract : TeamInvitationWrapper
  return (
    _jsx(Wrapper, { children: 
      _jsx(TeamInvitationDialog, { verifiedInvitation: verifiedInvitation,} )
    })
  )
}

export default TeamInvitation
